import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'
// import { encodeParams } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  return {
    getThirdLevelDomain: (params) =>
      `${baseURL}/api/thirdleveldomain?${encodeParams(params)}`,
    isDomainCustomizable: () => `${baseURL}/api/trackdomaincustomizable`,
    isDomainValid: (params) =>
      `${baseURL}/api/thirdleveldomainisvalid?${encodeParams(params)}`,
    addDomain: () => `${baseURL}/api/consoleclouddomain`,
    trackState: () => `${baseURL}/api/consoletrackstate`
  }
})(process.env.BEASYNCTRACKING_URL)

export const beAsyncTrackingApiGetThirdLevelDomain = (params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getThirdLevelDomain(params)
  }).then((res) => res.data)
}

export const beAsyncTrackingApiCheckTrackingDomainIsCustomizable = () => {
  return apiWrapper({
    method: 'get',
    url: endpoints.isDomainCustomizable()
  }).then((res) => res.data)
}

export const beAsyncTrackingApiCheckTrackingDomainIsValid = (params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.isDomainValid(params)
  }).then((res) => res.data)
}

export const beAsyncTrackingApiGetConsoleTrackState = () => {
  return apiWrapper({
    method: 'get',
    url: endpoints.trackState()
  }).then((res) => res.data)
}

export const beAsyncTrackingApiAddCustomDomain = (data) => {
  return apiWrapper({
    method: 'put',
    data: JSON.stringify(data),
    url: endpoints.addDomain()
  }).then((res) => res.data)
}
